import * as ActionTypes from './ActionTypes';

export const Finances = (state = {
        isLoading: true,
        errMess: null,
        finances: []
    }, action) => {
    switch(action.type) {
        case ActionTypes.ADD_FINANCES:
            return {...state, isLoading: false, errMess: null, finances: action.payload};

        case ActionTypes.FINANCES_LOADING:
            return {...state, isLoading: true, errMess: null, finances: []};

        case ActionTypes.FINANCES_FAILED:
            return {...state, isLoading: false, errMess: action.payload, finances: []};

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/finances.js